import { apiPaginatedClient } from '@/lib/api/api-client'
import type { Location } from '@/shared/types/location'

export type CatalogLocation = Location & {
  id: number
}

export const apiGetLocations = (query?: string, page = 1) => {
  const params = new URLSearchParams()
  const trimmed = query?.trim()

  if (trimmed) {
    params.set('query', trimmed)
  }

  params.set('page', String(page))

  return apiPaginatedClient<CatalogLocation[]>(
    `/api/v1/locations?${params.toString()}`
  )
}
